import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Layer } from '../models/layer.models';

@Injectable({
  providedIn: 'root'
})
export class LayerService {
  private baseUrl: string = environment.baseUrl;

  private layerObservable: ReplaySubject<Array<Layer>>;

  private layersState: {
    [key: string]: { active: boolean; order: number; layer: Layer };
  } = {};

  constructor(private http: HttpClient) {}

  public getLayers(): Observable<Array<Layer>> {
    const endpoint = `${this.baseUrl}/layers?sorts=user_order_position:asc`;
    if (!this.layerObservable) {
      this.layerObservable = new ReplaySubject<Array<Layer>>();
      this.http.get<Array<Layer>>(endpoint).subscribe((resp) => {
        this.layerObservable.next(resp);
      });
    }
    return this.layerObservable;
  }

  public reorderLayer(id: string, body: {after_layer_id: string, before_layer_id: string}): Observable<any> {
    const endpoint = `${this.baseUrl}/layers/${id}/reorder`;
    return this.http.post<any>(endpoint, body);
  }

  public setSavedLayers(layers: {
    [key: string]: { active: boolean; order: number; layer: Layer };
  }): void {
    this.layersState = layers;
  }

  public getSavedLayers(): {
    [key: string]: { active: boolean; order: number; layer: Layer };
    } {
    return this.layersState;
  }
  public generateLayers(): Observable<any> {
    // Note: This functionality might need to be implemented differently in the new API
    // For now, we'll return an empty observable
    console.warn(
      'generateLayers functionality may need to be reimplemented for the new API'
    );
    return new Observable<any>((observer) => {
      observer.complete();
    });
  }

  // New methods for the updated API

  public createLayer(layer: any): Observable<Layer> {
    const endpoint = `${this.baseUrl}/layers`;
    return this.http.post<Layer>(endpoint, layer);
  }

  public getLayer(id: string): Observable<Layer> {
    const endpoint = `${this.baseUrl}/layers/${id}`;
    return this.http.get<Layer>(endpoint);
  }

  public updateLayer(id: string, layer: Partial<Layer>): Observable<Layer> {
    const endpoint = `${this.baseUrl}/layers/${id}`;
    return this.http.put<Layer>(endpoint, layer);
  }

  public deleteLayer(id: string): Observable<any> {
    const endpoint = `${this.baseUrl}/layers/${id}`;
    return this.http.delete(endpoint);
  }
}
